import React from 'react'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { ROLE } from '../auth'
import { PrivateRoute } from '../auth/PrivateRoute'
import { ClientsList } from './routes/List'
import { ClientInfo } from './routes/Info'
import { EditClient } from './routes/Edit'
import { Transactions } from './routes/Transactions'
import { ClientDisputes } from './routes/Disputes'

const ClientsPage: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path='/list'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_OPERATOR,
                ROLE.ROLE_MATCHING_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <ClientsList />
            </PrivateRoute>
          }
        />
        <Route
          path='/info/:token'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_OPERATOR,
                ROLE.ROLE_MATCHING_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <ClientInfo />
            </PrivateRoute>
          }
        />
        <Route
          path='/edit/:token'
          element={
            <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}>
              <EditClient />
            </PrivateRoute>
          }
        />
        <Route
          path='/transactions/:token'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_OPERATOR,
                ROLE.ROLE_MATCHING_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <Transactions />
            </PrivateRoute>
          }
        />
        {/* CPAYMENT-1732: список ролей обязан совпадать с CLIENTS_PAGE_BREADCRUMBS и с бэкендом
            (DisputeController::MODULE_ROLES) — иначе пункт меню ведёт в 403 или наоборот. */}
        <Route
          path='/disputes/:token'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
                ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <ClientDisputes />
            </PrivateRoute>
          }
        />
        <Route index element={<Navigate to='/client' />} />
      </Route>
    </Routes>
  )
}

export default ClientsPage
